import axios from 'axios';


const service = axios.create({
    
    // baseURL: '/api',
    baseURL: 'http://3d.6a.com/frontend',
	headers: {
		'Content-Type': "application/x-www-form-urlencoded;"
	},
    timeout: 5000
});

service.interceptors.request.use(
    config => {
        
        return config
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return response.data;
        } else {
            Promise.reject();
        }
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;